export default "__VITE_ASSET__28a0be4a__"